/* Glabora US storefront enhancements: product page add-on, sticky buy bar, cart savings bar. US only. */
(function () {
  var TIERS = [{ n: 2, off: 10 }, { n: 3, off: 15 }, { n: 5, off: 20 }];
  function msg(n) {
    if (n >= 5) return 'You unlocked 20% off your order';
    if (n >= 3) return '15% off unlocked. Add ' + (5 - n) + ' more for 20% off';
    if (n === 2) return '10% off unlocked. Add 1 more for 15% off';
    if (n === 1) return 'Add 1 more piece to unlock 10% off';
    return 'Buy 2 save 10%, buy 3 save 15%, buy 5+ save 20%';
  }
  function barHTML(n) {
    var pct = Math.min(n, 5) / 5 * 100;
    return '<div class="us-cartbar__msg">' + msg(n) + '</div><div class="us-cartbar__track"><span style="width:' + pct + '%"></span></div>' +
      '<div class="us-cartbar__marks"><span>2 items<br>10%</span><span>3 items<br>15%</span><span>5 items<br>20%</span></div>';
  }
  var busy = false;
  function ensureCartBar() {
    var targets = [];
    var drawer = document.querySelector('cart-drawer .drawer__inner, cart-drawer .cart-drawer__inner, cart-drawer');
    var items = document.querySelector('cart-drawer cart-drawer-items') || document.querySelector('#CartDrawer-CartItems');
    var page = document.getElementById('main-cart-items');
    if (items && items.parentNode) targets.push({ ref: items, mode: 'before', id: 'us-cartbar-drawer' });
    if (page && page.parentNode) targets.push({ ref: page, mode: 'before', id: 'us-cartbar-page' });
    if (!targets.length || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      targets.forEach(function (t) {
        var el = document.getElementById(t.id);
        if (!el) { el = document.createElement('div'); el.id = t.id; el.className = 'us-cartbar'; t.ref.parentNode.insertBefore(el, t.ref); }
        el.innerHTML = c.item_count > 0 ? barHTML(c.item_count) : '';
        el.style.display = c.item_count > 0 ? '' : 'none';
      });
    }).catch(function () {}).then(function () { busy = false; });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(ensureCartBar, 250); }

  function placePdp() {
    var addon = document.getElementById('us-pdp-addon');
    if (!addon) {
      var tpl = document.getElementById('us-pdp-tpl');
      var form = document.querySelector('product-info .product-form, .product-form');
      if (tpl && form) { form.insertAdjacentHTML('afterend', tpl.innerHTML); }
    }
    if (!document.getElementById('us-look2')) {
      var lt = document.getElementById('us-look-tpl');
      var main = document.getElementById('MainContent');
      if (lt && main && lt.innerHTML.trim()) { main.insertAdjacentHTML('beforeend', lt.innerHTML); }
    }
    var st = document.getElementById('us-sticky-tpl');
    var submit = document.querySelector('product-info .product-form__submit, .product-form__submit');
    if (st && submit && !document.getElementById('us-sticky')) {
      document.body.insertAdjacentHTML('beforeend', st.innerHTML);
      var bar = document.getElementById('us-sticky');
      bar.querySelector('button').addEventListener('click', function () { if (submit.disabled) { submit.scrollIntoView({ behavior: 'smooth', block: 'center' }); } else { submit.click(); } });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(submit);
      }
    }
  }
  function init() { placePdp(); ensureCartBar(); new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Clickability safeguard: every product, category and button link always navigates */
(function () {
  try {
    var st = document.createElement('style');
    st.textContent = '.us-card__link,.us-cat,.us-ov,.us-ov2,a.us-btn,.us-look a,.us-moments a,.us-cats a{position:relative;z-index:1;cursor:pointer;pointer-events:auto}.us-cat::after,.us-ov::after,.us-hero__slide::after,.us-card__img::after{pointer-events:none}.us-card__img img,.us-cat__img img,.us-ov img{pointer-events:none}';
    document.head.appendChild(st);
  } catch (e) {}
  var SEL = 'a.us-card__link,a.us-cat,a.us-ov,a.us-ov2,a.us-btn,a.us-link,.us-look a,.us-hero a,.us-moments a,.us-cats a,.us-foot a';
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) === '#' || h.indexOf('mailto:') === 0 || h.indexOf('tel:') === 0 || a.target === '_blank') return;
    setTimeout(function () { if (e.defaultPrevented) { window.location.assign(a.href); } }, 0);
  });
})();

/* US favicon: monogram */
(function(){try{var svg="<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 80'><circle cx='40' cy='40' r='38.5' fill='#000'/><circle cx='40' cy='40' r='34' fill='none' stroke='#fff' stroke-width='.8'/><path d='M43.7 42H59V43.2H55.9V49.3Q55.1 50.5 53.9 52.1Q52.6 53.7 50.8 55.2Q49 56.6 46.5 57.6Q44 58.5 40.7 58.5Q35 58.5 31 55.9Q26.9 53.2 24.8 48.5Q22.7 43.8 22.7 37.8Q22.7 33.2 24.1 29.4Q25.5 25.6 28 22.8Q30.5 20 34 18.5Q37.4 17 41.5 17Q44.1 17 46.4 17.9Q48.8 18.7 50.7 20.3L54 17.5H55V28.8H53.9Q53.7 26.5 52.7 24.5Q51.7 22.6 50 21.2Q48.4 19.8 46.4 19Q44.3 18.3 42.1 18.3Q38.7 18.3 36.4 19.9Q34 21.5 32.6 24.3Q31.1 27.1 30.5 30.6Q29.8 34.1 29.8 37.8Q29.8 41.4 30.3 44.9Q30.8 48.4 32 51.3Q33.2 54.1 35.3 55.8Q37.4 57.5 40.7 57.5Q43 57.5 44.5 56.7Q46.1 56 47.1 54.9Q48.1 53.8 48.6 52.8Q49.1 51.8 49.4 51.2V43.2H43.7Z' fill='#fff'/></svg>";var href='data:image/svg+xml,'+encodeURIComponent(svg);document.querySelectorAll('link[rel~=icon]').forEach(function(l){l.parentNode.removeChild(l)});var l=document.createElement('link');l.rel='icon';l.type='image/svg+xml';l.href=href;document.head.appendChild(l);}catch(e){}})();
